import { render, staticRenderFns } from "./DisplayBtn.vue?vue&type=template&id=9b947c44&"
import script from "./DisplayBtn.vue?vue&type=script&lang=js&"
export * from "./DisplayBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports